import { startApp } from "./App/index.tsx";

startApp();
